<template>
  <div 
    class="cashback-list-header m-vertical-5 is-grid"
    :fill="false"
    grid
  >
    <div class="is-col-4 is-grid">
      <div class="is-col-6">
        <p>
          <small>
            Code d'inscription
          </small>
        </p>
      </div>

      <div class="is-col-6">
        <p>
          <small>
            Code d'abonnement
          </small>
        </p>
      </div>
    </div>

    <div class="is-col-8 is-grid has-no-col-gap">
      <div class="is-col-2">
        <p 
          class="is-pointer is-not-selectable"
          @click="setSignup"
        >
          <small>
            Inscription
          </small>

          <i 
            :class="[{
              'uil uil-angle-down': signup === -1,
              'uil uil-angle-up': signup === 1,
            }]"
          ></i>
        </p>
      </div>

      <div class="is-col-3">
        <p 
          class="is-pointer is-not-selectable"
          @click="setFirstSubscription"
        >
          <small>
            Premier abonnement
          </small>

          <i 
            :class="[{
              'uil uil-angle-down': firstSubscription === -1,
              'uil uil-angle-up': firstSubscription === 1,
            }]"
          ></i>
        </p>
      </div>

      <div class="is-col-2">
        <p 
          class="is-pointer is-not-selectable"
          @click="setSubscription"
        >
          <small>
            Abonnement
          </small>

          <i 
            :class="[{
              'uil uil-angle-down': subscription === -1,
              'uil uil-angle-up': subscription === 1,
            }]"
          ></i>
        </p>
      </div>

      <div class="is-col-1">
        <p>
          <small>
            TTC
          </small>
        </p>
      </div>

      <div class="is-col-1">
        <p>
          <small>
            HT
          </small>
        </p>
      </div>

      <div class="is-col-1">
        <p>
          <small>
            Gain
          </small>
        </p>
      </div>

      <div class="is-col-2">
        <p>
          <small>
            Type
          </small>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      signup: {
        type: Number,
        default: 0,
      },

      firstSubscription: {
        type: Number,
        default: 0,
      },

      subscription: {
        type: Number,
        default: 1,
      },
    },

    setup (props, context) {
      function setSort (value) {
        if (props[value] === 0) {
          context.emit(`update:${value}`, -1)
        } else if (props[value] === -1) {
          context.emit(`update:${value}`, 1)
        } else if (props[value] === 1) {
          context.emit(`update:${value}`, 0)
        }
      }

      function setSignup () {
        setSort('signup')
      }

      function setFirstSubscription () {
        setSort('firstSubscription')
      }

      function setSubscription () {
        setSort('subscription')
      }

      return {
        setSignup,
        setFirstSubscription,
        setSubscription,
      }
    },
  }
</script>

<style lang="scss">
  .cashback-list-header {
    padding: 0.45rem 1rem 0.45rem 1rem;
  }
</style>